const setNavigation = ({ navigation }) => ({
  type: 'SET_NAVIGATION',
  navigation,
});

export default {
  setNavigation,
};
